import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from "swiper/bundle";

function cleanFunction(container = document) {
  return new Promise((resolve) => {
    try {
     
      //  Kill all GSAP animations
      if (typeof gsap !== 'undefined') {
        gsap.killTweensOf("*");
        gsap.globalTimeline.clear();
        
        // Clear inline styles added by GSAP
        gsap.set(container.querySelectorAll('*'), { clearProps: "all" });
      }

      // Destroy Swiper instances
      if (typeof Swiper !== 'undefined') {
        // Find and destroy all Swiper instances
        const swipers = container.querySelectorAll('.swiper');
        swipers.forEach(swiperEl => {
          if (swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
          }
        });
        
      
        if (window.swiperInstances) {
          window.swiperInstances.forEach(swiper => swiper.destroy(true, true));
          window.swiperInstances = [];
        }
      }

      
      const videos = container.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      const audios = container.querySelectorAll('audio');
      audios.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
      });
       
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.killAll();
        ScrollTrigger.refresh();
      }
            
      //console.log('🧹 Essential cleanup completed');
      
      setTimeout(() => resolve(), 30);
      //resolve();

    } catch (error) {
      console.error('Cleanup error:', error);
      resolve();
    }
  });
}

export { cleanFunction };